import React from 'react';
import { LandingPage } from './components/LandingPage';
export function App() {
  return <div className="w-full min-h-screen" data-id="element-0">
      <LandingPage data-id="element-1" />
    </div>;
}